// extracted by mini-css-extract-plugin
module.exports = {"arrow":"GalleryCarouselNavigationButtonNext_arrow__3mK7j","buttonNext":"GalleryCarouselNavigationButtonNext_buttonNext__1cqNn"};